module.exports = __webpack_public_path__ + "img/madrid_chamartin.9e483234.jpg";